import PropTypes from "prop-types";
import CustomText from "./custom-text.atom";

const BUTTON_VARIANTS = {
  purple: {
    background: "#9747FF",
    text: "#FFFFFF",
  },
  yellow: {
    background: "#FACE07",
    text: "#000000",
  },
  white: {
    background: "#FFFFFF",
    text: "#000000",
    border: "2px solid #FACE07",
  },
};

const CustomButton = ({
  children,
  onClick,
  disabled = false,
  style,
  right,
  variant = "purple",
  ...props
}) => {
  // Asegurar que variant sea válido
  const validVariant = BUTTON_VARIANTS[variant] ? variant : "purple";
  const variantStyles = BUTTON_VARIANTS[validVariant];

  const buttonStyles = {
    ...styles.button,
    backgroundColor: variantStyles.background,
    border: variantStyles.border || "none",
    "&:hover": {
      backgroundColor: adjustColor(variantStyles.background, -10), // slightly darker on hover
    },
    ...(disabled && styles.disabled),
    ...style,
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={buttonStyles}
      {...props}
    >
      <div style={styles.content}>
        <CustomText
          variant="subtitleSmall"
          style={{
            ...styles.text,
            color: variantStyles.text,
            ...(disabled && styles.textDisabled),
          }}
        >
          {children}
        </CustomText>
        {right && right()}
      </div>
    </button>
  );
};

const adjustColor = (color, amount) => {
  const hex = color.replace("#", "");
  const r = Math.max(0, Math.min(255, parseInt(hex.slice(0, 2), 16) + amount));
  const g = Math.max(0, Math.min(255, parseInt(hex.slice(2, 4), 16) + amount));
  const b = Math.max(0, Math.min(255, parseInt(hex.slice(4, 6), 16) + amount));
  return `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
};

const styles = {
  button: {
    border: "none",
    borderRadius: "100px",
    padding: "10px 16px",
    cursor: "pointer",
    transition: "background-color 0.2s ease",
    width: "100%",
  },
  disabled: {
    backgroundColor: "#E0E0E0",
    cursor: "not-allowed",
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  text: {
    color: "#FFFFFF",
  },
  textDisabled: {
    color: "#ffffff",
  },
};

CustomButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  right: PropTypes.func,
  variant: PropTypes.oneOf(["purple", "yellow", "white"]),
};

export default CustomButton;
